import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RuntimeConfigService } from "./runtime-config.service";

/** One school's marketing/operations consent for the current guardian (mirrors CommunicationConsentDto). */
export interface CommunicationConsentItem {
  SchoolId: number;
  SchoolName?: string;
  Marketing: boolean;
  Operations: boolean;
}

@Injectable({ providedIn: 'root' })
export class CommunicationConsentService {
  private apiUrl: string;

  constructor(private http: HttpClient,
    private runtimeConfig: RuntimeConfigService) {
    this.apiUrl = this.runtimeConfig.currentConfig.apiUrl;
    this.runtimeConfig.config$.subscribe(config => {
      this.apiUrl = config.apiUrl;
    });
  }

  /** Schools the current guardian is associated with, pre-populated with any saved consent. */
  public getGuardianConsents(): Observable<CommunicationConsentItem[]> {
    return this.http.get<CommunicationConsentItem[]>(this.apiUrl + '/CommunicationConsent/GetGuardianConsentsAsync');
  }

  /** Saves the guardian's per-school marketing/operations selections. */
  public saveGuardianConsents(items: CommunicationConsentItem[]): Observable<void> {
    return this.http.post<void>(this.apiUrl + '/CommunicationConsent/SaveGuardianConsentsAsync', items);
  }

  /**
   * Saves the guardian's per-school selections (profile "Update" button) and returns the current
   * consent per school so the UI can reflect the persisted state without a second request.
   */
  public updateGuardianConsents(items: CommunicationConsentItem[]): Observable<CommunicationConsentItem[]> {
    return this.http.post<CommunicationConsentItem[]>(this.apiUrl + '/CommunicationConsent/UpdateGuardianConsentsAsync', items);
  }

  /**
   * True when the guardian has a current-year school with no consent on file (keyed by their phone).
   * Drives whether the consent modal is shown — re-triggers on a new school or a changed phone number.
   */
  public hasMissingConsent(): Observable<boolean> {
    return this.http.get<boolean>(this.apiUrl + '/CommunicationConsent/HasMissingConsentAsync');
  }
}
